// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import store from './store/store'

Vue.prototype.$http = axios
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.baseurl = process.env.baseurl;
Vue.prototype.actionurl = process.env.actionurl;
Vue.prototype.oarighturl = process.env.oarighturl;
Vue.prototype.env = process.env.NODE_ENV;
Vue.prototype.remark = process.env.remark;
Vue.prototype.$bus = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js